import { render, staticRenderFns } from "./SubmissionModal.vue?vue&type=template&id=31e6996d&"
import script from "./SubmissionModal.vue?vue&type=script&lang=js&"
export * from "./SubmissionModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionModal.vue?vue&type=style&index=0&id=31e6996d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports